import {
  Activity,
  Mail,
  Megaphone,
  MessageSquareText,
  Send,
  Settings,
  Shapes,
  Users,
  UsersRound,
  type LucideIcon,
} from "lucide-react";
import type { Permission } from "../api/types";

/** The admin pages, grouped: the admin sidebar, and the command palette (DECISIONS #53). */
export interface AdminSection {
  to: string;
  label: string;
  icon: LucideIcon;
  permission: Permission;
}

export const ADMIN_SECTIONS: [string, AdminSection[]][] = [
  [
    "People and access",
    [
      { to: "/admin/people", label: "People", icon: Users, permission: "manage_people_and_roles" },
      { to: "/admin/groups", label: "Groups", icon: UsersRound, permission: "manage_people_and_roles" },
    ],
  ],
  [
    "Service desk",
    [
      { to: "/admin/services", label: "Services", icon: Shapes, permission: "manage_catalogue" },
      { to: "/admin/saved-replies", label: "Saved replies", icon: MessageSquareText, permission: "manage_settings" },
    ],
  ],
  [
    "Updates",
    [
      { to: "/admin/service-status", label: "Service status", icon: Activity, permission: "post_service_updates" },
      { to: "/admin/announcements", label: "Announcements", icon: Megaphone, permission: "post_service_updates" },
    ],
  ],
  [
    "Monitoring",
    [
      { to: "/admin/deliveries", label: "Deliveries", icon: Send, permission: "view_delivery_failures" },
      { to: "/admin/email", label: "Held email", icon: Mail, permission: "manage_settings" },
    ],
  ],
  ["Desk", [{ to: "/admin/settings", label: "Settings", icon: Settings, permission: "manage_settings" }]],
];
